import { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../../constant/routeConstant';
import { getDetail } from '../../../../service/admin/data-group/dataGroupServices';
import moment from 'moment';


const useDetailDataGroup = () => {

  
  const { token } = useSelector(
    (state) => state.auth
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const [data, setData] = useState({});
  const [tab1, setTab1] = useState(true);
  const [tab2, setTab2] = useState(false);
  const [loading, setLoading] = useState(true);

  const [userManagementOpen, setUserManagementOpen] = useState(false)

  const getDetailDataGroup = async () => {
    try {
      const response = await getDetail(token, null, location?.state?.id, dispatch);
      if (response && response.ok) {
        setData(response.data);
        setLoading(false);
      }
    } catch (error) {
      return error;
    }
  }

  useEffect(() => {
    getDetailDataGroup()
  }, []);

  const convertTimestamp = (timestamp, isSpecific) => {
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];
    const monthNumbers = ["01", "02", "03", "04", "05", "06",
        "07", "08", "09", "10", "11", "12"
    ];

    // Extract components from the timestamp string
    const year = timestamp?.substring(0, 4);
    const month = timestamp?.substring(5, 7) - 1; // Months in JavaScript are 0-indexed
    const day = timestamp?.substring(8, 10);

    let dateFormat = new Date(year, month, day);

    if (isSpecific) {
        return (`${dateFormat.getDate()}-${monthNames[dateFormat.getMonth()]}-${dateFormat.getFullYear()}`)
    } else {
        return (`${dateFormat.getDate()}/${monthNumbers[dateFormat.getMonth()]}/${dateFormat.getFullYear()}`)
    }
  }

  const convertToTime = (timestamp) => {
    let time = new Date(timestamp);
    return (moment(timestamp).utc().format('HH:mm'))
  }

  const onChangeTab = (tab) => {
    switch (tab) {
      case 1:
        setTab1(true);
        setTab2(false);
        break;
      case 2:
        setTab1(false);
        setTab2(true);
        break;
      case 3:
        setTab1(false);
        setTab2(false);
        break;

      default:
        break;
    }
  }

  const handleBack = () => {
    navigate(ROUTES.DATA_GROUP.LIST)
  }

  const toEdit = () => {
    navigate(ROUTES.DATA_GROUP.EDIT, { state: { id: location?.state?.id, prevPage: location?.pathname } });
  }

  return {
    data,
    tab1,
    tab2,
    onChangeTab,
    handleBack,
    loading,
    toEdit,
    userManagementOpen,
    setUserManagementOpen,
    convertTimestamp
  }
}

export default useDetailDataGroup;